import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/ModelsTree/AddDepButton.tsx";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { IconButton } from '@mui/material';
import { Link, LinkOff } from '@mui/icons-material';
import * as smApi from '@gmini/sm-api-sdk';
import { RemoveDependencyDialog } from "../../RemoveDependencyDialog";
import { goals } from "../../../metrika";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AddDepButton = /*#__PURE__*/React.memo(function (_ref) {
  var currentEntity = _ref.currentEntity,
      elementsIncluded = _ref.elementsIncluded,
      isAdded = _ref.isAdded,
      disabled = _ref.disabled,
      bimFile = _ref.bimFile,
      onBeforeClick = _ref.onBeforeClick,
      dataTestId = _ref.dataTestId,
      seoEventHandler = _ref.seoEventHandler;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      removeDialogOpen = _React$useState2[0],
      setRemoveDialogOpen = _React$useState2[1];

  var onRemoveDialogClose = React.useCallback(function () {
    return setRemoveDialogOpen(false);
  }, []);
  var remove = currentEntity.type === 'UserClassifierNode' ? smApi.UserClassifier.removeDependency : smApi.AssemblyClassifier.removeDependency;
  var addDependency = currentEntity.type === 'UserClassifierNode' ? smApi.UserClassifier.addDependency : smApi.AssemblyClassifier.addDependency;

  var removeDependency = function removeDependency() {
    var baseClassifierId = bimFile.baseClassifierId;

    if (baseClassifierId) {
      remove.defaultContext.submit({
        id: currentEntity.id,
        version: currentEntity.version,
        sourceClassifierId: baseClassifierId
      });
      removeDialogOpen && setRemoveDialogOpen(false);
      seoEventHandler === null || seoEventHandler === void 0 ? void 0 : seoEventHandler(currentEntity.id, currentEntity.type, 'remove');
    }
  };

  var onAdd = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var id, type, _yield$smApi$BimFile$, baseClassifierId, baseClassifierVersion;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              goals.addModelDependency();
              id = currentEntity.id, type = currentEntity.type;
              seoEventHandler === null || seoEventHandler === void 0 ? void 0 : seoEventHandler(id, type);

              if (!(bimFile.status === 'ImportError' || bimFile.status === 'NotImported')) {
                _context.next = 12;
                break;
              }

              _context.next = 6;
              return smApi.BimFile.Import.defaultContext({
                bimFileUrn: bimFile.urn,
                bimFileVersion: bimFile.versionId,
                projectUrn: bimFile.projectUrn
              });

            case 6:
              _yield$smApi$BimFile$ = _context.sent;
              baseClassifierId = _yield$smApi$BimFile$.baseClassifierId;
              baseClassifierVersion = _yield$smApi$BimFile$.baseClassifierVersion;
              addDependency.defaultContext({
                id: currentEntity.id,
                version: currentEntity.version,
                sourceClassifierId: baseClassifierId,
                sourceClassifierVersion: baseClassifierVersion
              });
              _context.next = 13;
              break;

            case 12:
              addDependency.defaultContext({
                id: currentEntity.id,
                version: currentEntity.version,
                sourceClassifierId: bimFile.baseClassifierId,
                sourceClassifierVersion: bimFile.baseClassifierVersion
              });

            case 13:
              if (onBeforeClick) {
                onBeforeClick();
              }

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onAdd() {
      return _ref2.apply(this, arguments);
    };
  }();

  var onRemove = function onRemove() {
    onBeforeClick && onBeforeClick();

    if (elementsIncluded) {
      setRemoveDialogOpen(true);
    } else {
      removeDependency();
    }
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [removeDialogOpen && /*#__PURE__*/_jsx(RemoveDependencyDialog, {
      name: bimFile.name,
      type: bimFile.type,
      onClose: onRemoveDialogClose,
      removeDependency: removeDependency
    }), /*#__PURE__*/_jsx(IconButton, {
      disabled: disabled,
      size: "small",
      onClick: isAdded ? onRemove : onAdd,
      "data-test-id": dataTestId,
      children: isAdded ? /*#__PURE__*/_jsx(LinkOff, {
        color: "error"
      }) : /*#__PURE__*/_jsx(Link, {})
    })]
  });
});
AddDepButton.displayName = 'AddDepButton';